import { Backdrop, CircularProgress, Slider } from "@mui/material";
import { useEffect, useState } from "react";
import { RestfullApiService } from "../config/service";
import { useSelector } from "react-redux";

const Polls = () => {
  const user = useSelector((state) => state.user.userProfile);
  const [rating, setRating] = useState(0);
  const [fetchingPolls, setFetchingPolls] = useState(false);
  const [allPolls, setAllPolls] = useState([]);
  const [allEvents, setAllEvents] = useState([]);

  const handleRatingClick = (value, index) => {
    // setRange({
    //   ...range,
    //   [key]: newValue,
    // });
    setAllPolls((prevList) => {
      let updatedList = [...prevList];
      // if()
      // updatedList[index].Value = value;
      updatedList = updatedList?.map((poll) => {
        if (poll.Poll_Id === index) {
          return { ...poll, Value: value };
        }
        return poll;
      });

      return updatedList;
    });
  };

  // const handleRatingClick = (newRating) => {
  //   setRating(newRating);
  // };
  async function LoadPolls() {
    const reqdata = {
      Method_Name: "Get",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Poll_Id: "",
      Event_Id: "",
      Rating: 0,
    };
    try {
      setFetchingPolls(true);
      const result = await RestfullApiService(reqdata, "participant/Polls");
      if (result) {
        console.log(result?.data?.Result?.Table1);

        const pollsWithValue = result?.data?.Result?.Table1?.map((poll) => {
          return { ...poll, Value: poll.Rating ? poll.Rating : 0 };
        });

        setAllPolls(pollsWithValue);
        setAllEvents(result?.data?.Result?.Table2);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setFetchingPolls(false);
    }
  }
  async function UpdatePolls(poll, value) {
    const reqdata = {
      Method_Name: "Create",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Poll_Id: poll.Poll_Id,
      Event_Id: poll.Event_Id,
      Rating: value,
    };

    try {
      const result = await RestfullApiService(reqdata, "participant/Polls");
      if (result) {
      }
    } catch (err) {
      console.log(err);
    }
  }
  useEffect(() => {
    LoadPolls();
  }, []);

  return (
    <>
      {/* <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
        <div className="col-auto">
          <h1 className="text-20 lh-14 fw-600">
            Help Us Improve: Share Your Honest Feedback
          </h1>
        </div>
        <div className="col-auto"></div>
      </div> */}
      <div className="py-30 px-30 rounded-16 bg-white shadow-2 pb-60">
        {fetchingPolls ? (
          <div
            className="col-xl-12"
            style={{ position: "relative", height: "300px" }}
          >
            <Backdrop
              sx={{
                color: "#f05736",
                backgroundColor: "#fff",
                position: "absolute", // Make Backdrop absolute to the row div
                top: "50%", // Set the top position to 50%
                left: "50%", // Set the left position to 50%
                transform: "translate(-50%, -50%)", // Translate to center
                width: "100%",
                height: "100%",
                zIndex: 1, // Ensure it's above the content inside the row div
              }}
              open={fetchingPolls}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        ) : (
          <>
            {allPolls?.length < 1 && (
              <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
                <div className="col-auto pl-45">
                  <h1 className="text-20 lh-14 fw-600 text-primary">
                    No Polls at this moment
                  </h1>
                </div>
              </div>
            )}
            {allEvents?.map((event, index) => {
              return (
                <div
                  className={`row y-gap-20 pl-30${
                    index === allEvents?.length - 1 ? "" : " pb-30"
                  }`}
                >
                  <div className="col-auto">
                    <h1 className="text-18 lh-14 fw-600 text-primary">
                      {event?.Event_Name}
                    </h1>
                  </div>
                  {allPolls
                    ?.filter((poll) => poll.Event_Id === event.Event_Id)
                    ?.map((poll, index) => {
                      return poll?.Poll_Type === "Slider" ? (
                        <div className="col-12">
                          <h4 className="text-14 fw-600">{poll.Question}</h4>
                          <div className="range-container">
                            <Slider
                              id="range-2"
                              value={poll.Value}
                              onChange={async (e) => {
                                // handleRatingClick(e.target.value, index);
                                handleRatingClick(e.target.value, poll.Poll_Id);

                                UpdatePolls(poll, e.target.value);
                              }}
                              aria-label="Range Slider"
                              min={0}
                              max={poll.Max_Rating}
                              style={{ width: "75%", height: "10px" }}
                            />
                            <label
                              htmlFor="range-2"
                              className="range-label"
                              style={{
                                left: `calc(${
                                  (poll.Value / poll.Max_Rating) * 75
                                }% - 0px)`,
                                marginTop: "15px",
                              }}
                            >
                              {poll.Value}
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div className="col-12 ">
                          <h4 className="text-14 fw-600">{poll.Question}</h4>
                          <div className="text-18 lh-12 fw-600 mt-10 lg:mt-0 d-flex gap-15">
                            {Array(poll.Max_Rating)
                              .fill(0)
                              .map((_, index) => index + 1)
                              .map((star) => (
                                <i
                                  key={star}
                                  className={`fa-star text-primary text-22 ${
                                    star <= poll.Value ? "fas" : "far"
                                  }`}
                                  onClick={() => {
                                    // handleRatingClick(star, index);
                                    handleRatingClick(star, poll.Poll_Id);

                                    UpdatePolls(poll, star);
                                  }}
                                ></i>
                              ))}
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            })}
            {/* <div className="row y-gap-30 pl-30">
              {allPolls?.map((poll, index) => {
                return poll?.Poll_Type === "Slider" ? (
                  <div className="col-12 pt-40">
                    <h4 className="text-14 fw-600">{poll.Question}</h4>
                    <div className="range-container">
                      <Slider
                        id="range-2"
                        value={poll.Value}
                        onChange={async (e) => {
                          handleRatingClick(e.target.value, index);

                          UpdatePolls(poll, e.target.value);
                        }}
                        aria-label="Range Slider"
                        min={0}
                        max={poll.Max_Rating}
                        style={{ width: "75%", height: "10px" }}
                      />
                      <label
                        htmlFor="range-2"
                        className="range-label"
                        style={{
                          left: `calc(${(poll.Value / 10) * 75}% - 0px)`,
                          marginTop: "15px",
                        }}
                      >
                        {poll.Value}
                      </label>
                    </div>
                  </div>
                ) : (
                  <div className="col-12 pt-40">
                    <h4 className="text-14 fw-600">{poll.Question}</h4>
                    <div className="text-18 lh-12 fw-600 mt-10 lg:mt-0 d-flex gap-15">
                      {Array(poll.Max_Rating)
                        .fill(0)
                        .map((_, index) => index + 1)
                        .map((star) => (
                          <i
                            key={star}
                            className={`fa-star text-primary text-22 ${
                              star <= poll.Value ? "fas" : "far"
                            }`}
                            onClick={() => {
                              handleRatingClick(star, index);

                              UpdatePolls(poll, star);
                            }}
                          ></i>
                        ))}
                    </div>
                  </div>
                );
              })}
            </div> */}
          </>
        )}

        {/* <div className="row y-gap-30 pl-30">
          
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="d-flex x-gap-10 pt-20">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`fa-star text-30 fw-200 ${
                    star <= rating ? "fas" : "far"
                  }`}
                  onClick={() => handleRatingClick(star)}
                ></i>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Polls;
